import { ApiClient, ServiceResponse, ServiceResponseFactory, ServiceResponseNoContent } from "../../../common";
import { CreateFileDto } from "../../dtos/in/createFileDto";
import { UpdateFileDto } from "../../dtos/in/updateFileDto";
import { FileDto } from "../../dtos/out/fileDto";
import { BlobServiceClient } from '@azure/storage-blob';
import { IFilesClient } from "../interfaces/filesClient";
import { PlatformSettings } from "../../../settings/platformSettings";

class FileClient extends ApiClient implements IFilesClient {

	private _baseUrl: string;
	constructor(private platformSettings: PlatformSettings) {
		super();
		this._baseUrl = platformSettings.apiUrl + "/files";
	}

	get baseUrl(): string {
		return this._baseUrl;
	}

	public async getFile(fileId: string, accessToken: string): Promise<ServiceResponse<FileDto>> {
		return await super.Get<FileDto>(this.baseUrl, `${fileId}`, accessToken);
	}

	public async createFile(dto: CreateFileDto, accessToken: string): Promise<ServiceResponse<FileDto>> {
		return await super.Post<CreateFileDto, FileDto>(this.baseUrl, "", dto, accessToken);
	}

	public async updateFile(fileId: string, dto: UpdateFileDto, accessToken: string): Promise<ServiceResponse<FileDto>> {
		return await super.Put<UpdateFileDto, FileDto>(this.baseUrl, `${fileId}`, dto, accessToken);
	}

	public async deleteFile(fileId: string, accessToken: string): Promise<ServiceResponseNoContent> {
		return await super.Delete(this.baseUrl, `${fileId}`, accessToken);
	}

	public async uploadFile(dto: FileDto, file: File, onProgressUpdate = null): Promise<ServiceResponseNoContent> {

		try {
			// Create a new BlobServiceClient
			const blobServiceClient = new BlobServiceClient(dto.storageUrl + dto.sasToken);
			const containerClient = blobServiceClient.getContainerClient(dto.containerName);
			const blockBlobClient = containerClient.getBlockBlobClient(dto.name);

			const uploadBlobResponse = await blockBlobClient.uploadBrowserData(file, { onProgress: onProgressUpdate });

			const response = ServiceResponseFactory.SuccessfulResponseNoContent();
			response.wasSuccessful = true;
			return response;
		}
		catch {
			const response = ServiceResponseFactory.FailedSystemErrorResponse("Error uploading file");
			return response;
		}
	}
};

export { FileClient };